import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import { get } from 'lodash-es';
import { VisitorEntities } from 'client/data/models/visitor';
import { VehicleCard } from 'site-modules/profile/components/dashboard/vehicle-card/vehicle-card';
import { isLeadSubmitted } from 'site-modules/shared/components/profile/utils/extract-helper';

export function VehicleCards({
  isMobile = false,
  visitorLocation = null,
  vehicleCardsData,
  vinsWithLeads = {},
  removeCard = null,
  loadingInProgress,
  compareSelect = null,
}) {
  return vehicleCardsData.map(vin => (
    <Col tag="li" key={vin.vin} className="pb-1 px-0_25 px-md-0_5 dashboard-vin-cards-list" xs={12} md={6} lg={4}>
      <VehicleCard
        vinData={vin}
        isSubmittedLead={isLeadSubmitted(vinsWithLeads, vin)}
        submittedTs={get(vinsWithLeads, `["${vin.vin}"].submittedTs`)}
        removeCard={removeCard}
        loadingInProgress={loadingInProgress}
        compareSelect={compareSelect}
        visitorLocation={visitorLocation}
        isMobile={isMobile}
      />
    </Col>
  ));
}

VehicleCards.propTypes = {
  vehicleCardsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vinsWithLeads: PropTypes.shape({}),
  removeCard: PropTypes.func,
  loadingInProgress: PropTypes.bool.isRequired,
  savedVins: PropTypes.shape({}),
  compareSelect: PropTypes.shape({}),
  visitorLocation: VisitorEntities.Location,
  isMobile: PropTypes.bool,
};
